import { combineReducers } from "redux";

import postReducers from "./postReducers";
import categoryReducers from "./categoryReducers";
import userReducers from "./userReducers";

const rootReducer = combineReducers({
	posts: postReducers,
	categories: categoryReducers,
	users: userReducers,
});

export default rootReducer;
